import React from "react";
import { Field } from "formik";
import cx from "classnames";
import "./style.less";

const Checkbox = ({ name, value, onChange, children }) => {
  return (
    <Field type="checkbox" name={name} value={value}>
      {({ field, meta }) => {
        if (onChange) meta.touched && onChange(meta.error);

        return (
          <div
            className={cx("checkbox-wrapper", {
              checked: field.checked,
            })}>
            <label className="cursor-pointer">
              <input type="checkbox" className="hidden" {...field} />
              <span className="font-mulish checkbox-label">{children}</span>
            </label>
          </div>
        );
      }}
    </Field>
  );
};

export default Checkbox;
